import React, { MouseEventHandler } from 'react';
import ReactPaginate from 'react-paginate';
import { PaginationNext, PaginationPrev } from './ProjectIcons';
import { useTranslation } from 'react-i18next';
import { paginationClasses } from './tailwindClassnames';

type PaginationProps = {
    showText: boolean,
    handlePageClick?: Function,
    handleNextPageClick?: MouseEventHandler,
    handlePrevPageClick?: MouseEventHandler,
    pageCount?: number,
    resultStart?: number,
    resultEnd?: number,
    prevCursor?: string,
    nextCursor?: string,
    totalCount?: number,
    take: number,
    loading: boolean,
    mainclassname: string,
    initialPage?: number;
    pageRangeDisplayed?: number;
    marginPagesDisplayed?: number;
}

const Pagination = ({
    showText,
    handlePageClick,
    handlePrevPageClick,
    handleNextPageClick,
    pageCount,
    resultStart,
    resultEnd,
    prevCursor,
    nextCursor,
    totalCount,
    take,
    loading,
    mainclassname,
    initialPage,
    pageRangeDisplayed,
    marginPagesDisplayed
}: PaginationProps) => {
    const { t } = useTranslation();
    // Whether there is anywhere to go — the same conditions the labels below
    // use. Held here so the button chrome can be withheld too: a null label
    // still renders its anchor, and with chrome on it that would be an empty
    // white box sitting where a control isn't.
    const hasPrev = !!(prevCursor || (totalCount && totalCount > take));
    const hasNext = !!(nextCursor || (totalCount && totalCount > take));
    return (
        <div className={mainclassname}>
            {showText ?
                <div>
                    {totalCount && (totalCount > 0) && (
                        loading ? (
                            <span className={`w-full py-2 ${paginationClasses.text}`}>
                                {t("Loading")}...
                            </span>
                        ) : (
                            <span className={`w-full py-2 ${paginationClasses.text}`}>
                                {t("Showing")} {resultStart} {t("to")} {resultEnd} {t("partitive of")} {totalCount}
                            </span>
                        )
                    )}
                </div> :
                <div>
                    {/* {totalCount > 0 && <span className='w-full text-ui-text-primary-text py-2'>Load more</span>} */}
                </div>
            }
            <ReactPaginate
                previousLabel={((prevCursor) || (totalCount && totalCount > take)) ? <div onClick={handlePrevPageClick}><PaginationPrev /></div> : null}
                nextLabel={((nextCursor) || (totalCount && totalCount > take)) ? <div onClick={handleNextPageClick}><PaginationNext /></div> : null}
                breakLabel={". . ."}
                pageCount={pageCount && pageCount ? pageCount : 100}
                onPageChange={(e) => handlePageClick && handlePageClick(e)}
                containerClassName={"pagination flex flex-row items-center gap-2 justify-end my-0 mx-8"}
                pageClassName={showText ? "" : "hidden"}
                pageLinkClassName={paginationClasses.button}
                activeClassName={"active"}
                activeLinkClassName={`${paginationClasses.button} ${paginationClasses.buttonActive}`}
                breakLinkClassName={paginationClasses.text}
                previousLinkClassName={hasPrev ? paginationClasses.button : "hidden"}
                nextLinkClassName={hasNext ? paginationClasses.button : "hidden"}
                forcePage={initialPage}
                pageRangeDisplayed={pageRangeDisplayed}
                marginPagesDisplayed={marginPagesDisplayed}
            />
        </div>
    )
}

export default Pagination;